import MenuItemsUc from "../../use_cases/menuItemsUc";
import MenuItemRepository from "../../models/repository/menuItemRepository";
import {defineStore} from "pinia";
import {markRaw} from "vue";
import {useLoginStore} from "@/menu/context/stores/loginStore";
import {getApi} from "@/shared/axios";

export const useMenuItemStore = defineStore("menuStore", {
  state: () => ({
    menuItems: [],
    filteredMenuItems: [],
    selectedMenu: 0,
    selectedSubmenu: null,
    externalMenu: false,
    uc: null,
  }),
  actions: {
    initializeConfig() {
      if (this.uc) return

      const api = getApi()

      const repository = new MenuItemRepository(api)
      this.uc = new MenuItemsUc(repository)
    },
    getSelectedMenu() {
      return parseInt(localStorage.getItem("selectedMenu")) ?? 0
    },
    setSelectedMenu(index) {
      this.selectedMenu = index
      localStorage.setItem("selectedMenu", index)
    },
    setSelectedSubMenu(index) {
      this.selectedSubmenu = index
    },
    setExternalMenu(value) {
      this.externalMenu = value
    },
    changeExternalMenu() {
      this.externalMenu = !this.externalMenu
      this.setFilteredMenu()
      localStorage.setItem("externalMenu", this.externalMenu)
    },
    setFilteredMenu() {
      const filteredMenu = this.menuItems
        .filter(item => item.getExternal() === this.externalMenu)
        .map(item => markRaw(item))

      if (this.externalMenu) {
        const loginStore = useLoginStore()
        const actualProject = loginStore.getActualProject()
        if (!actualProject || actualProject.isPostpaid()) {
          this.filteredMenuItems = filteredMenu
            .filter(item => item.getApplyCoupon() ? actualProject.getApplyCoupon() : !item.getPrepaid())
            .map(item => markRaw(item))
        } else {
          this.filteredMenuItems = filteredMenu
            .filter(item => item.getApplyCoupon() ? actualProject.getApplyCoupon() : true)
            .map(item => markRaw(item))
        }
      } else {
        this.filteredMenuItems = filteredMenu
      }
    },
    async loadMenuItems(cityId, userId) {
      try {
        const response = await this.uc.allMenuItemsUc(cityId, userId)

        this.menuItems = markRaw(response.menus)
        this.setFilteredMenu()
      } catch (error) {
        console.error("loadMenuItems -> ", error)
      }
    }
  }
})
